'use client';
import React, { useMemo } from 'react';
import { useI18n } from '@locales/client';

import { WrapperBanner } from './styles';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { Button } from '@/shared/ui/form/button';
import { Box } from '@/shared/ui/box';
import { useConfirmDataPrompt } from '@/features/data-managment/model/hooks';
import { useUser } from '@/shared/providers/user-provider/use-user';

const BannerPrompts = () => {
  const t = useI18n();
  const { showBanner, role, onPopupShow } = useConfirmDataPrompt();
  const { user } = useUser();

  const shouldShowBanner = useMemo(
    () => showBanner && !user?.telegram && role !== 'player',
    [showBanner, user?.telegram, role]
  );

  const handleClick = () => {
    onPopupShow();
  };

  if (!shouldShowBanner) return null;

  return (
    <WrapperBanner>
      <BodyTextMediumC>
        {t('account_verification.accountDataVerification')}
      </BodyTextMediumC>
      <Box>
        <Button onClick={handleClick} variant="orangeGradient">
          <BodyTextMediumC>{t('account_verification.confirm')}</BodyTextMediumC>
        </Button>
      </Box>
    </WrapperBanner>
  );
};

export { BannerPrompts };
